export const parseStringParam = (
  params: URLSearchParams,
  key: string
): string => {
  const value = params.get(key);
  if (!value) return "";
  const trimmed = value.trim();
  if (!trimmed) return "";
  const normalized = trimmed.toLowerCase();
  if (normalized === "undefined" || normalized === "null") return "";
  return trimmed;
};

export const parseStringArrayParam = (
  params: URLSearchParams,
  key: string
): string[] => {
  const values = params.getAll(key);
  const raw =
    values.length > 0
      ? values
      : params.get(key)
      ? [params.get(key) as string]
      : [];
  const normalized = raw
    .flatMap((value) => value.split(","))
    .map((value) => value.trim())
    .filter(Boolean);
  return Array.from(new Set(normalized));
};

export const parseBooleanParam = (
  params: URLSearchParams,
  key: string
): boolean | undefined => {
  const raw = params.get(key);
  if (raw === null) return undefined;
  const normalized = raw.trim().toLowerCase();
  if (["true", "1", "yes"].includes(normalized)) return true;
  if (["false", "0", "no"].includes(normalized)) return false;
  return undefined;
};

export const buildQueryParams = (
  values: Record<string, string | string[] | boolean | null | undefined>
): URLSearchParams => {
  const params = new URLSearchParams();
  Object.entries(values).forEach(([key, value]) => {
    if (value === null || value === undefined) return;
    if (Array.isArray(value)) {
      const cleaned = value
        .map((item) => String(item).trim())
        .filter(Boolean);
      if (cleaned.length > 0) {
        params.set(key, cleaned.join(","));
      }
      return;
    }
    if (typeof value === "boolean") {
      params.set(key, value ? "true" : "false");
      return;
    }
    if (value !== "") {
      params.set(key, value);
    }
  });
  return params;
};

export const buildQueryString = (
  values: Record<string, string | string[] | boolean | null | undefined>
): string => {
  const params = buildQueryParams(values);
  const query = params.toString();
  return query ? `?${query}` : "";
};
